import { FALLBACK_LNG, initTranslations } from '../../services/i18n'
import type { ShellHook } from './models'

export const initializeI18n: ShellHook = async shell => {
  const authContext = shell.getAuthContext()
  await initTranslations(
    authContext.me?.locale ?? FALLBACK_LNG,
    /* https://jira.ops.expertcity.com/browse/SCORE-1312— Insert baseUrl for i18n, e.g. "/foo/i18n/static/" should we have it. This gets executed client side. */
  )
}
